module.exports = __webpack_public_path__ + "static/media/28.1335d2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/28.png
// module id = 1069
// module chunks = 0